import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState
} from 'react';
interface TopTip {
  id: string;
  text: string;
  likes: number;
  dislikes: number;
}

interface Top {
  top_tips: TopTip[];
}
interface Iroprs {
  setIsModalOpen: (open: boolean) => void;
  top: Top[];
  toptipText: string;
  setToptipText: Dispatch<SetStateAction<string>>;
  handleSubmit: () => Promise<void>;
  pageType?: string; //for temporary disable submit button on things-todo page
}

const AddTopTipModal = ({
  setIsModalOpen,
  pageType,
  toptipText,
  setToptipText,
  handleSubmit
}: Iroprs) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const handleToptipChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;

    if (newText.trim() === '') {
      setToptipText('');
      setErrorMessage('Top tip cannot be empty.');
    } else {
      // Check if the new text contains more than 3 consecutive spaces
      if (/\s{3,}/.test(newText)) {
        setToptipText(toptipText);
        setErrorMessage('Only up to 3 consecutive spaces are allowed.');
      } else {
        if (newText.length >= 1 && newText.length < 50) {
          setIsButtonDisabled(true);
          setErrorMessage('Minimum length should be 50 characters.');
        } else if (newText.length >= 100) {
          setErrorMessage('Maximum length cannot be more than 100 characters.');
        } else {
          setIsButtonDisabled(false);
          setErrorMessage('');
        }
        setToptipText(newText);
      }
    }
  };

  const modalRef: any = useRef(null);

  const handleCloseModal = (e: any) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleCloseModal);
    return () => {
      document.removeEventListener('mousedown', handleCloseModal);
    };
  }, []);

  return (
    <>
      {/* Modal Wrapper z-index should be 1150 or in between 1100 and 1200 */}
      <div className="fixed inset-0  z-[1150] bg-gray-800 bg-opacity-50 flex items-center justify-center">
        <div
          ref={modalRef}
          className="bg-white rounded-md w-[90%] md:w-[530px]"
        >
          <div className=" m-2 flex justify-end">
            <span
              className="cursor-pointer px-2 py-1"
              onClick={() => setIsModalOpen(false)}
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.398438"
                  y="0.5"
                  width="20.5989"
                  height="20"
                  rx="10"
                  fill="#DEDEDE"
                />
                <path
                  d="M14.7681 7.51358C14.8398 7.44442 14.897 7.36169 14.9363 7.27021C14.9757 7.17872 14.9964 7.08032 14.9973 6.98074C14.9982 6.88115 14.9793 6.78238 14.9416 6.69019C14.904 6.598 14.8483 6.51424 14.7779 6.44379C14.7076 6.37333 14.6238 6.31761 14.5317 6.27985C14.4395 6.2421 14.3408 6.22307 14.2412 6.22389C14.1416 6.22471 14.0432 6.24535 13.9517 6.28462C13.8602 6.32388 13.7774 6.38098 13.7081 6.45258L10.7021 9.45758L7.69715 6.45258C7.62848 6.37889 7.54568 6.31979 7.45368 6.27879C7.36168 6.2378 7.26237 6.21576 7.16167 6.21398C7.06097 6.21221 6.96094 6.23073 6.86755 6.26845C6.77416 6.30617 6.68933 6.36232 6.61811 6.43354C6.54689 6.50476 6.49074 6.58959 6.45302 6.68298C6.4153 6.77637 6.39678 6.8764 6.39855 6.9771C6.40033 7.0778 6.42237 7.17711 6.46336 7.26911C6.50436 7.36111 6.56346 7.44391 6.63715 7.51258L9.64015 10.5186L6.63515 13.5236C6.50267 13.6658 6.43054 13.8538 6.43397 14.0481C6.4374 14.2424 6.51611 14.4278 6.65352 14.5652C6.79094 14.7026 6.97632 14.7813 7.17062 14.7847C7.36492 14.7882 7.55297 14.7161 7.69515 14.5836L10.7021 11.5786L13.7071 14.5846C13.8493 14.7171 14.0374 14.7892 14.2317 14.7858C14.426 14.7823 14.6114 14.7036 14.7488 14.5662C14.8862 14.4288 14.9649 14.2434 14.9683 14.0491C14.9717 13.8548 14.8996 13.6667 14.7671 13.5246L11.7641 10.5186L14.7681 7.51358Z"
                  fill="black"
                />
              </svg>
            </span>
          </div>
          <div className=" px-6 md:px-8 pb-4">
            <h2 className="text-lg mb-4">Share your Top Tip</h2>

            <form>
              <textarea
                value={toptipText}
                onChange={handleToptipChange}
                placeholder="Write Top Tip"
                rows={4}
                minLength={50}
                maxLength={100}
                required
                className="w-full p-2 mb-1"
                style={{
                  borderRadius: '15px',
                  border: '1px solid #DFDFDF',
                  background: '#EEE'
                }}
              />
              <div className="flex justify-between mb-5">
                <div className="justify-start">
                  {errorMessage && (
                    <p className="text-blue-500 text-sm">{errorMessage}</p>
                  )}
                </div>
                {toptipText.length > 0 && (
                  <p className="flex justify-end ">{`${toptipText.length}/100`}</p>
                )}
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={`bg-[#1F2C5B] text-white px-4 py-2 rounded-[8px] hover:bg-[#2E3D7A] active:bg-[#2E3D7A] ${
                    isButtonDisabled && 'opacity-50 cursor-not-allowed'
                  }`}
                  disabled={isButtonDisabled}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTopTipModal;
